export const buildGraphData = ({ query, variables }, args) => {
  const data = {};

  if (query) data.query = query(args);

  if (variables) data.variables = variables(args);

  return data;
};
